<div
  class="component-wrapper e-contract"
  *ngIf="typeScreen && typeScreen === 'econtract'"
>
  <div class="logo">
    <img
      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/about-wifi-6/logo-hifpt.svg"
      alt=""
      width="auto"
      height="auto"
    />
  </div>
  <div class="button-wrapper">
    <a href="{{ linkStore }}">Tải ứng dụng</a>
    <a href="{{ linkContract }}">Tiếp tục sử dụng web</a>
  </div>
</div>
<div
  class="component-wrapper normal-link"
  *ngIf="typeScreen && typeScreen === 'normal'"
>
  <div class="logo">
    <img
      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/about-wifi-6/logo-hifpt.svg"
      alt=""
      width="auto"
      height="auto"
    />
  </div>
  <div class="button-wrapper">
    <a href="{{ deepLink }}" class="bg-button">Mở ứng dụng</a>
  </div>
</div>
